import { numberToBrl } from "../../../utils/currency.utils";
import { SummaryUnit } from "./types";

export const formatAmountToString = (amount: number, unit?: SummaryUnit) => {
  if (unit === SummaryUnit.BRL_CURRENCY) {
    return numberToBrl(amount);
  }

  return String(amount);
};
